import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserAstronaut,
  faSpinnerThird
} from '@fortawesome/pro-regular-svg-icons';

const avatarSizes: Record<
  string,
  { imgSize: string; padding: string; iconSize: string }
> = {
  medium: { imgSize: '8rem', padding: '1.5rem', iconSize: '4rem' },
  large: { imgSize: '14.5rem', padding: '5rem', iconSize: '10rem' }
};

const StyledAvatar = styled.div<{
  src?: string;
  isLoading?: boolean;
  avatarSize: 'medium' | 'large';
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  height: ${({ avatarSize }) => avatarSizes[avatarSize].imgSize};
  width: ${({ avatarSize }) => avatarSizes[avatarSize].imgSize};
  border-radius: 4px;
  ${({ isLoading }) =>
    isLoading &&
    css`
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
    `}
  ${({ src, isLoading }) =>
    src
      ? css`
          background: ${isLoading
              ? 'linear-gradient(0deg,rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)),'
              : ''}
            url('${src}');
          background-size: cover;
        `
      : css`
          background-color: var(--color-mono-95);
        `}
  svg {
    font-size: ${({ avatarSize }) => avatarSizes[avatarSize].iconSize};
    color: var(--color-mono-80);
  }
`;

export const Loader = styled(FontAwesomeIcon)<{
  avatarSize: 'medium' | 'large';
}>`
  position: absolute;
  top: ${({ avatarSize }) => avatarSizes[avatarSize].padding};
  left: ${({ avatarSize }) => avatarSizes[avatarSize].padding};

  font-size: 4rem !important;
  color: var(--color-mono-100) !important;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

interface IAvatarProps {
  src?: string;
  isLoading?: boolean;
  avatarSize?: 'medium' | 'large';
}

const Avatar = ({ src, isLoading, avatarSize = 'medium' }: IAvatarProps) => {
  return (
    <StyledAvatar src={src} isLoading={isLoading} avatarSize={avatarSize}>
      {!src && <FontAwesomeIcon icon={faUserAstronaut} />}
      {isLoading && (
        <Loader icon={faSpinnerThird} avatarSize={avatarSize || 'medium'} />
      )}
    </StyledAvatar>
  );
};
export default Avatar;
